import React, {useState} from 'react';
import {ErrorMessage, Field, Form, Formik} from 'formik';
import * as Yup from 'yup';
import 'pages/login/_login.scss';
import {Header, Loader} from 'components';
import {useDispatch, useSelector} from 'react-redux';
import {authExtraActions, generalExtraActions} from 'reduxStore/actions';
import {useNavigate} from 'react-router-dom';
import {routes} from 'common';
import ComLoader from 'components/comLoader/ComLoader';

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  password: Yup.string()
    .required('Password is required'),
});

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {loading, isUserLoggedIn} = useSelector((state) => state.auth);

  React.useEffect(() => {
    if (isUserLoggedIn) {
      console.log("here")
      navigate(routes.GROUNDS);
    }
  }, [isUserLoggedIn, navigate]);

  const handleSubmit = (values, {setSubmitting}) => {
    dispatch(
      authExtraActions.login({
        email_or_phone: values.email,
        password: values.password,
      })
    )
  };

  return (
    <div className="login-container">
      <Header/>
      <div className="login-content-wrapper">
      <div className="login-content">
        <h2 className="login-title">Log in</h2>
        <p className="login-subtitle">Welcome! Please enter your details.</p>
        <Formik
          initialValues={{email: '', password: ''}}
          validationSchema={loginSchema}
          onSubmit={handleSubmit}
        >
          {({errors, touched}) => (
            <Form className="custom-form">
              <label>Email <span className="required">*</span></label>
              <Field
                type="email"
                name="email"
                placeholder="example@email.com"
                className={`form-control ${touched.email && errors.email ? 'is-invalid' : ''}`}
              />
              <ErrorMessage name="email" component="div" className="error-message"/>
              <label>Password <span className="required">*</span></label>
              <Field
                type="password"
                name="password"
                placeholder="password"
                className={`form-control ${touched.password && errors.password ? 'is-invalid' : ''}`}
              />
              <ErrorMessage name="password" component="div" className="error-message"/>
              <button className="submit-btn" type="submit" disabled={loading}>
                {loading ? <ComLoader/> : 'Log In'}
              </button>
            </Form>
          )}
        </Formik>
      </div>
      </div>
    </div>
  );
};

export default Login; 